export class Pergunta{
        
    id : number;
    pergunta : string;
}